import React, { useState, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import './css/LightGrid.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar';
import { Layout } from "antd";
import CustomHeader from '../Layout/Header';
import Select, { components } from 'react-select';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import ReactSelectArrowBlack from '../CommonComponent/ReactSelectArrowBlack';
import LightGridicon from './img/lightgrid-icon.png';
import { dataUser } from '../Helpers/util';
import axios from 'axios';
import LocationIcon from './img/location-icon.svg';
import firebaseApp from '../../Config/firebaseConfig';
import moment from 'moment';
import {
  getDatabase,
  ref,
  onValue,
  get,
  onChildChanged,
} from 'firebase/database';

function LightGridInfo() {
  const [selectedLocation, setSelectedLocation] = useState(null);
       const [collapsed, setCollapsed] = useState(true); 
  const [locationId, setLocationId] = useState(null);
  const [locationData, setLocationData] = useState([]);
  const [location2, setLocation2] = useState('');
  const [floorSpoc, setFloorSpoc] = useState([]);
  const [fetchLcsData, setFetchLcsData] = useState([]);
  const [firebaseData, setFirebaseData] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [allLocationStatusTrue, setAlLocationStatusTrue] = useState(true);
  const [selectedDeviceData, setSelectedDeviceData] = useState(null);
    const [loading, setLoading] = useState(true);

  const userDataLocal = dataUser();
  var UserObj = JSON.parse(userDataLocal);

  // Function to update Firebase data
  const updateMap = (key1, obj, data) => {
    Object.keys(data).forEach(key => {
      if (key === key1) {
        data[key] = obj;
      }
    });
    setFirebaseData(data);
  };
  const toggleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let authToken = JSON.parse(localStorage.getItem('headData'));
        const axiosConfig = {
          params: {
            spoc: UserObj.rec_id,
            client: UserObj?.company_id,
          },
          headers: {
            Authorization: `${authToken?.spintlyToken}`,
          },
        };

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
          axiosConfig,
        );

        if (response.data.status === 'success') {
          const formattedData = response.data.data.map(item => ({
            value: item?.rec_id,
            label: item.location_name,
            centercode: item.centercode,
          }));
          setLocationData(formattedData);
        }
      } catch (error) {
        console.error(error);
      }
    };


    const initialize=()=>{
      fetchData();
    }
    initialize();
   
  }, []);

  const floorData = async centercode => {
    try {
      const authToken = JSON.parse(localStorage.getItem('headData'))
        ?.spintlyToken;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}basic-data/get-floor`,
        {
          params: { location: centercode },
          headers: { Authorization: authToken },
        },
      );

      if (response.data.status === 'success') {
        setFloorSpoc(response.data.data);
        if (response.data.data.length > 0) {
          const defaultFloor = {
            value: response.data.data[0].rec_id,
            label: response.data.data[0].floor_name,
          };
          setLocation2(defaultFloor);
        }
      }
    } catch (error) {
      console.error('Error fetching floor data:', error);
    }
  };

  useEffect(() => {
    if (locationData.length > 0) {
      const defaultLocation = locationData[0];
      changeSelect(defaultLocation);
    }
  }, [locationData]);

  const changeSelect = async selectedOption => {
    setSelectedLocation(selectedOption);
    setLocationId(selectedOption.value);

    const selectedLocation = locationData.find(
      item => item.value === selectedOption.value,
    );

    const centercode = selectedLocation?.value;

    await floorData(centercode); 

    const fetchWorkingTimes = async () => {
      const localData = JSON.parse(localStorage.getItem('headData'));
      const authToken = localData?.spintlyToken;
      const selectedFloorId = location2 ? [location2.value] : [];
      if (selectedFloorId.length > 0 && locationData.length > 0) {
        const feedbackData = {
          locationIds: [selectedOption.value], 
          floorIds: selectedFloorId,
        };

        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}bms/fetch-lcs/${
              UserObj.company_id
            }`,
            feedbackData,
            {
              headers: { Authorization: authToken },
            },
          );

          if (res.data.success) {
            setFetchLcsData(res.data.data.data);
          }
        } catch (err) {
          console.error('API call error:', err);
        }
      } else {
        console.warn('FloorIds or locationData not available yet.');
      }
    };

    if (locationData.length > 0 && location2) {
      fetchWorkingTimes();
    }

    if (!firebaseApp) return;
    const db = getDatabase(firebaseApp);
    const dataRef = ref(
      db,
      `${process.env.REACT_APP_FIREBASE_ENV}/LCS/${selectedOption.value}/${
        UserObj.company_id
      }`,
    );

    try {
      const snapshot = await get(dataRef);
      const data = snapshot.val();
      if (data) {
        setFirebaseData(data);
      }

      const unsubscribe = onChildChanged(dataRef, snapshot => {
        updateMap(snapshot.key, snapshot.val(), data);
      });
      return () => unsubscribe(); 
    } catch (error) {
      console.error('Error fetching Firebase data:', error);
    } finally {
    }
  };

  const fetchWorkingTimes = async (
    selectedLocationId,
    selectedFloorId,
    authToken,
  ) => {
    const feedbackData = {
      locationIds: [selectedLocationId],
      floorIds: selectedFloorId ? [selectedFloorId] : [], 
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}bms/fetch-lcs/${UserObj.company_id}`,
        feedbackData,
        {
          headers: { Authorization: authToken },
        },
      );

      if (res.data.success) {
        setFetchLcsData(res.data.data.data);
      }
    } catch (err) {
      console.error('API call error:', err);
    }
  };

  const handleFloorChange = selectedOption => {
    setLocation2(selectedOption);
    setSelectedDeviceId(''); 
    const localData = JSON.parse(localStorage.getItem('headData'));
    if (selectedOption) {
      fetchWorkingTimes(
        locationId,
        selectedOption.value,
        localData?.spintlyToken,
      );
    }
  };

  

  const updatedOptions = locationData.map(option => ({
    ...option,
    isDisabled: selectedLocation
      ? option.value === selectedLocation.value
      : false,
  }));

  useEffect(() => {
    const fetchWorkingTimes = async () => {
      const localData = JSON.parse(localStorage.getItem('headData'));
      const authToken = localData?.spintlyToken;
      const selectedFloorId = location2 ? [location2.value] : [];
  
      if (selectedFloorId.length > 0 && locationData.length > 0) {
        const feedbackData = {
          locationIds: locationData.map(location => location.value), // Pass all location IDs
          floorIds: selectedFloorId,
        };
  
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}bms/fetch-lcs/${UserObj.company_id}`,
            feedbackData,
            {
              headers: { Authorization: authToken },
            }
          );
  
          if (res.data.status === 200) {
            setFetchLcsData(res.data.data.data);
          }
        } catch (err) {
          console.error('API call error:', err);
        }
      } else {
        console.warn('FloorIds or locationData not available yet.');
      }
    };
  
    const fetchFirebaseData = async () => {
      if (!firebaseApp) return;
      const db = getDatabase(firebaseApp);
      const dataRef = ref(
        db,
        `${process.env.REACT_APP_FIREBASE_ENV}/LCS/${locationData.map(
          location => location.value
        )}/${UserObj.company_id}`
      );
  
      try {
        const snapshot = await get(dataRef);
        const data = snapshot.val();
        if (data) {
          setFirebaseData(data);
        }
  
        // Set up the listener for child changes
        const unsubscribe = onChildChanged(dataRef, snapshot => {
          updateMap(snapshot.key, snapshot.val(), data);
        });
  
        return unsubscribe; // Return the unsubscribe function for cleanup
      } catch (error) {
        console.error('Error fetching Firebase data:', error);
      }
    };
  
    // Effect cleanup function for Firebase
    const cleanUpFirebase = async () => {
      const unsubscribe = await fetchFirebaseData();
      return unsubscribe;
    };
  
    // Trigger fetch on initial load, if conditions are met
    if (locationData.length > 0 && location2 && allLocationStatusTrue) {
      fetchWorkingTimes(); // Call on initial load
  
      setAlLocationStatusTrue(false);
    }
  
    // Return the cleanup function for Firebase listener
    return () => {
      cleanUpFirebase(); // Cleanup the Firebase listener
    };
  
  }, [locationData, location2, allLocationStatusTrue]); 

  const handleDeviceClick = async device => {
    const data = fetchLcsData?.filter(
      d => d.deviceId === device.details.deviceId,
    )?.[0];

    setSelectedDeviceData(data);
    setSelectedDeviceId(device.details.deviceId);

  };


  useEffect(() => {
    if (selectedDeviceData) {
     
    }
  }, [selectedDeviceData]);

  const convertUTCtoISTInHHMM = utcTimestamp => {
    return moment
      .utc(utcTimestamp)
      .tz('Asia/Kolkata')
      .format('hh:mm A');
  };

  

  const daysOfWeek = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday'
  };

  return (
    <Layout>
      
    <Sidebar collapsed={collapsed} />

    <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
    

    <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
          <div className="PageContent">
        <div className="LG-info-header">
            <div className='row'>
              <div className='col-md-6'>
                <div className='SwHeading'>
                    <h2>
                      <span>Light grid</span>
                      <img src={LightGridicon} alt="" width={24} />
                    </h2>
                </div>
              </div>
              <div className='col-md-6'>
                <div className="LG-info-locations justify-content-end">
                    <div className="locatn">
                    {/* <img src={LocationIcon} alt="" /> */}
                    <SwSelect 
                      options={updatedOptions}
                      value={selectedLocation}
                      onChange={changeSelect}
                      placeholder="Select Location"
                      isSearchable
                      isClearable={false}
                      // styles={{MinWidth:'200px'}}
                    />
                    </div>
                    <div className='LG-info_Flrs'>
                    <SwSelect
                      options={floorSpoc
                        .sort((a, b) => a.business_name.localeCompare(b.floor_name))
                        .map(item => ({
                          value: item.rec_id,
                          label: item.floor_name,
                        }))
                      }
                      value={location2}
                      onChange={handleFloorChange}
                      placeholder="Floor"
                      isSearchable={false}
                      isClearable={false}
                    />

                    </div>
                </div>
              </div>
          </div>

          <div className="DeviceSelection_row">
            {firebaseData
              ? Object.keys(firebaseData).map(key => {
                  const device = firebaseData[key];
                  if (!device.details) {
                    return null;
                  }
                  const matchingLcsDevice = fetchLcsData.find(
                    lcsDevice => lcsDevice.deviceId === device.details.deviceId,
                  );

                  if (!matchingLcsDevice) {
                    return null;
                  }

                  const isSelectedD =
                    selectedDeviceId === device.details.deviceId;
                  return (
                    <div
                      key={key}
                      className={`Light_DeviceName ${
                        isSelectedD ? 'SelectedDevice' : ''
                      }`}
                      onClick={() => handleDeviceClick(device)}
                    >
                      {matchingLcsDevice?.name}
                    </div>
                  );
                })
              : ''}
          </div>

          {/* need to implement in future */}
        </div>

        <div className="LG_Info_Accordion">
          <Accordion defaultActiveKey={['0']} className='SwAccordion'>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Default schedule</Accordion.Header>
              <Accordion.Body>
                <div className="DefaultShcdl">
                  {selectedDeviceData?.workingTime.map(
                    (schedule, index) =>
                      schedule.startTime &&
                      schedule.endTime && (
                        <div className="DefaultShcdl_row" key={index}>
                          <div className="Default_Days">
                            {daysOfWeek[schedule.day]}
                          </div>{' '}
                          {/* Map day number to weekday */}
                          <div className="Default_Time">
                            {convertUTCtoISTInHHMM(schedule.startTime)} -{' '}
                            {convertUTCtoISTInHHMM(schedule.endTime)}
                          </div>
                        </div>
                      ),
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>What is Light grid ?</Accordion.Header>
              <Accordion.Body>
                Light Grid is an all-in-one platform designed for clients and
                their SPOCs to seamlessly manage and monitor electricity usage
                across their workspaces, ensuring efficient energy consumption
                and cost savings.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>What can SPOCs do?</Accordion.Header>
              <Accordion.Body>
                <ul className='SwList SwList--bullet'>
                  <li>Check Default Schedule for each day of the week</li>
                  <li>Check today's schedule</li>
                  <li>
                    Select Device (if there are multiple) and check their status
                  </li>
                  <li>Check current status</li>
                  <li>Manually Switch On/Off</li>
                  <li>
                    Schedule additional working hours before and after default
                    working hours
                  </li>
                  <li>
                    Schedule additional working hours for a future date as well
                  </li>
                  <li>Modify/Cancel the added hours before their onset </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>How to do it?</Accordion.Header>
              <Accordion.Body>
                <ul className='SwList SwList--bullet'>
                  <li>SPOCs need to login to the CSPOC portal</li>
                  <li>
                    They will find a section called 'Light Grid' on the home
                    page of the portal
                  </li>
                  <li>
                    SPOCs can check schedules on clicking on the info icon
                  </li>
                  <li>
                    SPOCs can use the 'Schedule New Hours' button to add
                    additional working hours for the day and 7 days in advance
                  </li>
                  <li>
                    Once the additional working hours are added, they can use
                    the edit and cancel icon on the top of the section to modify
                    or cancel the added hours respectively
                  </li>
                  <li>
                    By clicking on 'Turn Off' button, SPOCs can choose to turn
                    off the lights instantly
                  </li>
                  <li>
                    Enter the OTP sent to their designated email ID to complete
                    the action
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>Things to keep in mind</Accordion.Header>
              <Accordion.Body>
                <ul className='SwList SwList--bullet'>
                  <li>
                    There will be a cooldown time of 15 minutes after each
                    switch on/off
                  </li>
                  <li>
                    They can’t modify or cancel once the added hours are active
                    but can turn lights off
                  </li>
                  <li>
                    There will be an OTP based authentication for each action
                  </li>
                  <li>
                    There will be a maximum and minimum duration of 15 minutes
                    that can be set for adding the hours
                  </li>
                  <li>
                    Addition of working hours can be done for the same day or
                    future date as well (one at a time)
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      </Layout>
        
        </Layout>
  );
}

export default connect()(LightGridInfo);
